import { Base, withDrag } from '@studiometa/js-toolkit';
/**
 *
 */
export default class SliderDrag extends withDrag(Base, {
  target: (instance) => instance.$el,
  dampFactor: 0,
}) {
  twoFingers = false;
  isSnapping = false;
  /**
   * Config.
   */
  static config = {
    name: 'SliderDrag',
    emits: ['start', 'drag', 'drop', 'inertia', 'stop'],
    options: {
      scrollLockThreshold: {
        type: Number,
        default: 10,
      },
      maxVelocity: {
        type: Number,
        default: 20,
      },
      snapThreshold: {
        type: Number,
        default: 0.3,
      },
    },
  };

  /**
   * Test if the scroll should be blocked. Used with the touchmove event to prevent
   * scrolling vertically when trying to drag the slider.
   * @returns {number} distance
   */
  get shouldPreventScroll() {
    const { distance } = this.$services.get('dragged');
    return (
      Math.abs(distance.x) > this.$options.scrollLockThreshold &&
      Math.abs(distance.x) > Math.abs(distance.y)
    );
  }

  /**
   * Check if two fingers touche the device
   * @param {object} props
   * @param {Event} props.event
   */
  onTouchstart({ event }) {
    this.twoFingers = event.touches.length === 2;
    // Annule le snap si l'utilisateur commence à toucher
    if (this.isSnapping) {
      this.cancelSnap();
    }
  }

  /**
   * Check if two fingers touche the device
   * @param {object} props
   * @param {Event} props.event
   */
  onTouchend({ event }) {
    this.twoFingers = event.touches.length === 2;

    // Si on termine le drag, forcer le snap
    if (event.touches.length === 0) {
      this.snapToNearestSlide();
    }
  }

  /**
   * Prevent Scroll ?
   * @param {object} props
   * @param {Event} props.event
   */
  onTouchmove({ event }) {
    if (this.shouldPreventScroll) {
      event.preventDefault();
    }
  }

  /**
   * Emit drag events.
   * @param {*} props Object
   * @returns {void}
   */
  dragged(props) {
    if (this.twoFingers) {
      return;
    }

    // Limite la distance de drag pour éviter des mouvements trop brusques
    const { delta } = props;
    const maxVelocity = this.$options.maxVelocity;

    // Limite la vélocité pour éviter les mouvements trop rapides
    if (delta && Math.abs(delta.x) > maxVelocity) {
      props.delta.x = Math.sign(delta.x) * maxVelocity;
    }

    this.$emit(props.mode, props);
  }

  /**
   * Force le snap vers la slide la plus proche
   */
  snapToNearestSlide() {
    const firstItem = this.$el.querySelector('[data-component="SliderItem"]');
    if (!firstItem) return;

    this.isSnapping = true;

    const currentTransform = firstItem.style.transform;
    const currentX = currentTransform
      ? Number.parseFloat(currentTransform.match(/translate3d\(([^,]+)px/)?.[1] || 0)
      : 0;
    const slideWidth = this.$el.offsetWidth;

    // Calcule quelle slide est la plus proche
    const currentSlide = Math.round(-currentX / slideWidth);
    const targetX = -currentSlide * slideWidth;

    // Applique la transformation à tous les SliderItems
    const sliderItems = this.$el.querySelectorAll('[data-component="SliderItem"]');
    sliderItems.forEach((item) => {
      item.style.transform = `translate3d(${targetX}px, 0px, 0px)`;
    });
  }

  /**
   *
   */
  cancelSnap() {
    if (this.snapTimeout) {
      clearTimeout(this.snapTimeout);
      this.snapTimeout = null;
    }
    this.isSnapping = false;

    // Retire immédiatement les transitions
    const sliderItems = this.$el.querySelectorAll('[data-component="SliderItem"]');
    sliderItems.forEach((item) => {
      item.style.transition = '';
    });
  }
}
